import styled from 'styled-components'
import { colors } from '../../../../styles/constants'
import Button from '../../../../components/Form/Button'
import Skeleton from 'react-loading-skeleton'

const CARD_BOX_SIZES = {
  title: {
    width: '190px',
    height: '20px',
    borderRadius: '8px',
    marginBottom: '4px'
  },
  subtitle: {
    width: '290px',
    height: '20px',
    borderRadius: '8px',
    marginBottom: '24px'
  },
  cardTop: {
    width: '100%',
    height: '278px',
    borderRadius: '12px',
    marginBottom: '24px'
  },
  cardBottom: {
    width: '100%',
    height: '334px',
    borderRadius: '12px',
    marginBottom: '32px'
  }
}

export const Container = styled.div`
  margin: 0 16px 24px 16px;
  span {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Title = styled.h1`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  color: ${colors.gray.dark};
  margin-bottom: 4px;
`

export const Subtitle = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 24px;
  color: ${colors.gray.dark};
`
export const WarningCard = styled.div`
  background-color: ${colors.blue.lighter};
  border-radius: 12px;
`

export const SkeletonCard = styled(Skeleton)`
  width: ${({ type }) => CARD_BOX_SIZES[type].width ?? 'inherit'};
  height: ${({ type }) => CARD_BOX_SIZES[type].height ?? 'inherit'};
  border-radius: ${({ type }) => CARD_BOX_SIZES[type].borderRadius ?? '0'};
  margin-bottom: ${({ type }) => CARD_BOX_SIZES[type].marginBottom ?? '0'};
`

export const CardWrapper = styled.div`
  margin: 24px 0;
`

export const CardBody = styled.div`
  width: 100%;
`

export const CardSection = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 24px;
    :last-child {
    margin-bottom: 0;
  }
    svg {
      flex-shrink: 0;
    }
`

export const CardTitle = styled.h2`
  font-family: 'Nunito';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: ${colors.gray.darker};
  margin-bottom: 4px;
  strong {
    font-size: 20px;
    color: ${colors.cyan.default};
    font-weight: 600;
    letter-spacing: 0.96px;
  }
`

export const CardSubtitle = styled.h2`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: ${colors.gray.dark};
  margin-bottom: 0;
  strong {
    font-size: 14px;
    font-weight: 600;
  }
`

export const Avatar = styled.img`
  display: block;
`

export const ActionButton = styled(Button)`
  width: 112px;
  margin-top: -8px;
`
